define("preview-grid/controllers/media-item", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "later/utils/constants", "later/utils/focus"], function (_exports, _controller, _object, _service, _tracking, _constants, _focus) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _savedCaptionSegmentEvent, _closeModal;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"later/utils/constants",0,"later/utils/focus"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let MediaItemController = _exports.default = (_class = (_savedCaptionSegmentEvent = /*#__PURE__*/new WeakSet(), _closeModal = /*#__PURE__*/new WeakSet(), class MediaItemController extends _controller.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _closeModal);
      _classPrivateMethodInitSpec(this, _savedCaptionSegmentEvent);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor6, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor7, this);
      _initializerDefineProperty(this, "router", _descriptor8, this);
      _initializerDefineProperty(this, "savedCaptionToEdit", _descriptor9, this);
      _initializerDefineProperty(this, "editingCaption", _descriptor10, this);
      _defineProperty(this, "comments", []);
      _defineProperty(this, "location", null);
      _defineProperty(this, "showComments", true);
      _defineProperty(this, "viewDetail", false);
      _defineProperty(this, "needsApprovalOpen", false);
    }
    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get mediaItem() {
      return this.model;
    }
    get hasSecondary() {
      return this.secondaryModal.isModalOpen() || this.needsApprovalOpen;
    }
    get groupLabels() {
      return this.model.group.get('labels');
    }
    get canEditLabel() {
      return !this.currentGroup.contributor;
    }
    get canDestroyMedia() {
      return !(this.currentGroup.contributor && this.mediaItem.approved);
    }
    get hasDirtyAttributes() {
      return this.model.get('dirtyType') === 'updated';
    }
    get canCreatePost() {
      if (!this.socialProfile) {
        return false;
      } else if (this.showUpgradeButton) {
        return false;
      } else if (this.model.processing && !this.model.isVideo) {
        return false;
      } else if (this.model.failed) {
        return false;
      } else if (this.model.isVideo && !this.socialProfile.canPostVideo) {
        return false;
      } else if (this.model.isGif && !this.socialProfile.canPostGif) {
        return false;
      } else if (this.socialProfile.isTiktok && this.model.isImage) {
        return false;
      } else if (!this.socialProfile.hasPublishingMethod) {
        return false;
      } else if (this.currentAccount.stopTheWorldOrPastDue) {
        return false;
      }
      return true;
    }
    get rejectCreatePostReason() {
      if (!this.socialProfile) {
        return this.intl.t('alerts.preview_grid.share_calendar.something_went_wrong');
      } else if (!this.socialProfile.hasPostsLeft) {
        return this.intl.t('media_items.update.max_posts');
      } else if (this.model.processing) {
        return this.intl.t('media_items.update.processing_post');
      } else if (this.model.failed) {
        return this.intl.t('media_items.update.failed_media');
      } else if (this.model.isVideo && !this.socialProfile.canPostVideo) {
        return this.intl.t('posts.modal.unsupported_video_platform.pinterest_message');
      } else if (this.model.isGif && !this.socialProfile.canPostGif) {
        return this.intl.t('posts.modal.unsupported_gif_platform', {
          platform: this.socialProfile.accountType
        });
      } else if (!this.socialProfile.hasPublishingMethod) {
        return this.intl.t('posts.modal.notification_publish.need_device', {
          platform: this.socialProfile.accountType
        });
      } else if (this.socialProfile.isTiktok && this.model.isImage) {
        return this.intl.t('alerts.tiktok.errors.invalid_media.message');
      } else if (this.currentAccount.stopTheWorldOrPastDue) {
        return this.intl.t('posts.modal.stop_the_world');
      }
      return null;
    }
    get hasLabels() {
      return this.model.labels.get('length') > 0;
    }
    get createPostText() {
      const isPinterest = this.socialProfile?.isPinterest;
      return this.intl.t(isPinterest ? 'calendar.modal.pinterest.create_post' : 'calendar.modal.create_post');
    }
    get showUpgradeButton() {
      return !this.socialProfile?.hasPostsLeft;
    }
    get linkingSocialProfile() {
      return this.socialProfile || this.auth.currentSocialProfile;
    }
    get isViewingMultiCal() {
      return this.selectedSocialProfiles.hasMultipleSelected;
    }
    get singleSocialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }
    canClose() {
      if (this.hasDirtyAttributes) {
        this.dialogManager.confirm(this.intl.t('media_items.update.close_save')).then(() => this.model.save()).then(() => _classPrivateMethodGet(this, _closeModal, _closeModal2).call(this));
      } else if (this.savedCaptionToEdit?.isNew || this.savedCaptionToEdit?.hasDirtyAttributes) {
        this.dialogManager.confirm(this.intl.t('media_items.update.close_save')).then(() => {
          const isNewSavedCaption = this.savedCaptionToEdit?.isNew;
          this.savedCaptionToEdit?.save().then(() => {
            if (isNewSavedCaption) {
              _classPrivateMethodGet(this, _savedCaptionSegmentEvent, _savedCaptionSegmentEvent2).call(this, 'saved-new-caption', this.savedCaptionToEdit?.title);
            }
            this.savedCaptionToEdit = null;
            _classPrivateMethodGet(this, _closeModal, _closeModal2).call(this);
          });
        });
      } else {
        this.model.rollbackAttributes();
        _classPrivateMethodGet(this, _closeModal, _closeModal2).call(this);
      }
    }
    saveModelIfDirty() {
      if (this.hasDirtyAttributes) {
        // gets called when user hits "Create Post" and media item is in a dirty state --G
        this.model.save();
      }
    }
    saveEditedCaption() {
      this.model.save().then(() => {
        this.segment.track('updated-media-notes', {
          group_id: this.currentGroup.id,
          media_id: this.model.id,
          media_url: this.model.isVideo ? this.model.videoUrl : this.model.imageUrl,
          notes: this.model.defaultCaption,
          location: this.location
        });
      }).catch(adapterError => {
        this.errors.handleAdapter(adapterError, this.model);
        this.model.rollbackAttributes();
      });
      this.editingCaption = false;
      this.secondaryModal.removeModal();
    }
    cancelEditingCaption() {
      this.model.rollbackAttributes();
      this.editingCaption = false;
      this.secondaryModal.removeModal();
    }
    toggleCaptionTemplate() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.SAVED_CAPTIONS);
    }
    toggleSmartHashtags() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.SMART_HASHTAGS);
    }
    toggleCaptionWriter() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.CAPTION_WRITER);
    }
    toggleSecondary(type, location) {
      this.secondaryModal.toggleModal(this.uniqueId, type, location);
    }
    async rollbackSavedCaption() {
      try {
        if (this.savedCaptionToEdit?.isNew) {
          await this.savedCaptionToEdit.deleteRecord();
        } else if (this.savedCaptionToEdit?.hasDirtyAttributes) {
          await this.savedCaptionToEdit.rollbackAttributes();
        }
        this.savedCaptionToEdit = null;
      } catch (error) {
        this.errors.handleAdapter(error);
      }
    }
    editCaption() {
      this.editingCaption = true;
      (0, _focus.default)('#textareaMediaNote');
    }
    editPost(post_id) {
      this.router.transitionTo('cluster.schedule.calendar.post.edit', post_id);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "savedCaptionToEdit", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "editingCaption", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "canClose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "canClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveModelIfDirty", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveModelIfDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveEditedCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveEditedCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditingCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditingCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCaptionTemplate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCaptionTemplate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSmartHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSmartHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCaptionWriter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCaptionWriter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSecondary", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSecondary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rollbackSavedCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "rollbackSavedCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editPost"), _class.prototype)), _class);
  function _savedCaptionSegmentEvent2(eventName, savedCaptionTitle) {
    this.segment.track(eventName, {
      group_id: this.currentGroup.id,
      location: 'media_item',
      saved_caption_title: savedCaptionTitle ?? ''
    });
  }
  function _closeModal2() {
    this.router.transitionTo('cluster.schedule.preview-grid');
  }
});